import React from 'react';
import {
  EVENT_KIND_ICONS,
  EVENT_KIND_LABELS,
  normalizeEventKind,
} from '../../utils/eventKind';

/**
 * Die Art eines Termins als Abzeichen: Ausfahrt, Event oder Stammtisch.
 *
 * Eine Komponente für alle Anzeigeorte (Terminzeile, Terminkarte, Tabelle im
 * Termin-Editor) - die Farbzuordnung soll überall dieselbe sein. Beschriftung
 * und Icon kommen aus utils/eventKind.js, nicht von hier: Das ist die
 * einzige Quelle dafür, und sie hat einen Backend-Spiegel.
 *
 * Das Icon ist `aria-hidden` - die Beschriftung steht direkt daneben und
 * sagt dasselbe.
 */
export default function EventKindBadge({ event }) {
  const kind = normalizeEventKind(event);

  return (
    <span className={`mt-badge mt-badge--kind-${kind}`}>
      <span aria-hidden="true">{EVENT_KIND_ICONS[kind]}</span> {EVENT_KIND_LABELS[kind]}
    </span>
  );
}
